/* AZ & CO. — quantity on a bag line.

   The bag could add and it could remove, and nothing in between. A second
   tap on Add put two bottles in, and the only way back to one was Remove,
   which took both.

   Kept out of theme.js on purpose. theme.js owns the markup and repaints
   #cart-lines wholesale; this only reaches into what it painted and
   re-inserts itself afterwards, so deleting this file and its two lines in
   snippets/cart-drawer.liquid restores the previous behaviour exactly.

   The cart page needs none of this: its stepper is two links rendered by
   Liquid, which work with JavaScript off.

   ---------------------------------------------------------------------
   Speed, and then steadiness.

   The number moves on the press and the server is told afterwards. That
   made it quick and made it jump: presses are collected into one request
   after a short pause, so pressing four times can send a request for two,
   and then keep going. The reply for two lands while the screen already
   says four, and if the reply is allowed to paint, the number falls back
   and climbs again. That is the flicker — not the network being slow, but
   an answer to a question that is no longer the one being asked.

   So every request carries a sequence number and only the newest one is
   allowed to paint. Anything older is read for stock and otherwise
   discarded. The same guard covers theme.js's own /cart.js reads, which
   were equally capable of overwriting a press that had not been sent yet.
   --------------------------------------------------------------------- */

(function () {
  'use strict';

  var state = null;       // the cart, as last seen or as last guessed
  var retail = new Map(); // handle -> Promise<Map<variant id, compare-at>>

  var queued = null;      // { key, quantity } waiting for the pause to end
  var timer = null;
  var sent = 0;           // sequence of the last request sent
  var acked = 0;          // sequence of the last request painted
  var touched = false;    // has anyone used the stepper yet this page

  var WAIT = 240;

  /* True while the screen is ahead of the server: a press in the buffer, or
     a request out that has not come back. Nothing from the network may
     repaint quantities while this holds. */
  function ahead () {
    return queued !== null || sent !== acked;
  }

  function money (cents) {
    var n = Math.round(cents / 100).toLocaleString('en-US');
    return ((window.AZ && window.AZ.currency) || 'AED') + ' ' + n;
  }

  function announce (msg) {
    var region = document.getElementById('cart-live');
    if (region) region.textContent = msg;
  }

  function itemFor (key) {
    if (!state || !state.items) return null;
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].key === key) return state.items[i];
    }
    return null;
  }

  /* ------------------------------------------------------------- snooping

     theme.js already asks for /cart.js whenever the bag changes and for
     /products/<handle>.js to price the saving. Rather than ask again, this
     reads the answers on their way past. One wrapper, installed before
     theme.js runs — the drawer snippet is rendered above its script tag in
     the layout, and deferred scripts run in document order.

     Responses are cloned, so nothing downstream sees a consumed body.

     Our own /cart/change.js replies are deliberately not handled here.
     They are handled at the call site, where the sequence number is. */

  var native = window.fetch;
  if (typeof native === 'function' && !native.azQty) {
    var wrapper = function (input) {
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var out = native.apply(this, arguments);

      if (/\/cart(\/update)?\.js(\?|$)/.test(url)) {
        out.then(function (r) {
          if (!r || !r.ok) return;
          return r.clone().json().then(function (c) {
            if (!c || !c.items) return;
            // a read that started before the press it would undo
            if (ahead()) return;
            state = c;
            paint();
          });
        }).catch(function () {});
      } else {
        var m = url.match(/\/products\/([^/?#]+)\.js(\?|$)/);
        if (m && !retail.has(m[1])) {
          retail.set(m[1], out.then(function (r) {
            return r && r.ok ? r.clone().json() : null;
          }).then(toRetail).catch(function () { return new Map(); }));
        }
      }

      return out;
    };
    wrapper.azQty = true;
    window.fetch = wrapper;
  }

  function toRetail (p) {
    var m = new Map();
    if (p && p.variants) p.variants.forEach(function (v) { m.set(v.id, v.compare_at_price); });
    return m;
  }

  function retailMap (handle) {
    if (!retail.has(handle)) {
      retail.set(handle, native('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(toRetail)
        .catch(function () { return new Map(); }));
    }
    return retail.get(handle);
  }

  /* cart.js carries no compare-at price, so the retail figure comes from the
     product JSON. Only recalculated once somebody has touched the stepper:
     on first paint theme.js is doing this itself, and running it here as
     well would double the requests for no visible difference. */
  function paintSaved () {
    var row = document.getElementById('cart-saved');
    var out = document.getElementById('cart-saved-value');
    if (!row || !out || !state) return;

    var handles = [];
    state.items.forEach(function (i) {
      if (handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });

    Promise.all(handles.map(retailMap)).then(function (maps) {
      var saved = 0;
      state.items.forEach(function (it) {
        var m = maps[handles.indexOf(it.handle)] || new Map();
        var r = m.get(it.variant_id);
        // a few bottles carry a compare-at at or below the selling price
        if (r && r > it.final_price) saved += (r - it.final_price) * it.quantity;
      });
      if (saved > 0) { out.textContent = money(saved); row.hidden = false; } else { row.hidden = true; }
    }).catch(function () { row.hidden = true; });
  }

  /* Minus is disabled rather than hidden at one. Hiding it moves the plus
     under your thumb between taps, which is how you buy three. Remove is
     directly below and already has undo behind it. */
  function stepper (qty) {
    var d = document.createElement('div');
    d.className = 'qty';
    d.setAttribute('data-qty', '');
    d.innerHTML =
      '<button type="button" class="qty-btn" data-qty-step="-1" aria-label="One fewer"' +
        (qty <= 1 ? ' disabled' : '') + '>\u2212</button>' +
      '<span class="qty-n" data-qty-n>' + qty + '</span>' +
      '<button type="button" class="qty-btn" data-qty-step="1" aria-label="One more">+</button>';
    return d;
  }

  function paint () {
    var host = document.getElementById('cart-lines');
    if (!host || !state) return;

    var lines = host.querySelectorAll('.bag-line');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var it = itemFor(line.getAttribute('data-key'));
      if (!it) continue;

      var id = line.querySelector('.bag-id');
      var box = line.querySelector('[data-qty]');
      if (!box && id) {
        box = stepper(it.quantity);
        var rm = id.querySelector('[data-remove]');
        if (rm) id.insertBefore(box, rm); else id.appendChild(box);
      }
      if (box) {
        var n = box.querySelector('[data-qty-n]');
        if (n && n.textContent !== String(it.quantity)) n.textContent = it.quantity;
        var minus = box.querySelector('[data-qty-step="-1"]');
        // never disable under a thumb mid-press; it swallows the next one
        if (minus) minus.disabled = it.quantity <= 1;
      }

      var price = line.querySelector('.bag-price');
      if (price) price.textContent = money(it.final_line_price);
    }

    var total = document.getElementById('cart-total');
    if (total) total.textContent = money(state.total_price);

    var count = document.getElementById('bag-count');
    if (count) {
      count.textContent = state.item_count;
      count.hidden = state.item_count === 0;
    }

    if (touched) paintSaved();
  }

  /* The guess. Reconciled against the server's answer a moment later, so it
     only has to be right often enough not to flicker — and for a quantity
     on a line it is simply right. */
  function guess (key, quantity) {
    var it = itemFor(key);
    if (!it) return;
    it.quantity = quantity;
    it.final_line_price = it.final_price * quantity;
    it.line_price = (it.price || it.final_price) * quantity;

    var total = 0;
    var units = 0;
    state.items.forEach(function (x) { total += x.final_line_price; units += x.quantity; });
    state.total_price = total;
    state.item_count = units;
  }

  function send () {
    timer = null;
    if (!queued) return;

    var job = queued;
    queued = null;

    var mine = ++sent;
    var route = (window.AZ && window.AZ.routes && window.AZ.routes.cart_change) || '/cart/change';

    // native, not the wrapper: this reply is reconciled here, by sequence
    native(route + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: job.key, quantity: job.quantity })
    }).then(function (r) { return r.json(); }).then(function (c) {
      var line = document.querySelector('.bag-line[data-key="' + job.key + '"]');
      var got = null;
      (c.items || []).forEach(function (i) { if (i.key === job.key) got = i; });

      /* Shopify caps the quantity at what is in stock and hands the capped
         cart back without complaint. Silently ignoring a press is the part
         people read as broken, so the line says why. Worth reading off even
         a superseded reply — the ceiling does not move between presses. */
      if (line) {
        if (got && got.quantity < job.quantity) line.setAttribute('data-capped', '');
        else line.removeAttribute('data-capped');
      }

      /* Superseded. Someone pressed again while this was in the air, so the
         screen is already showing a later number and this one is history.
         Painting it is exactly the jump we are here to avoid. */
      if (mine !== sent) return;

      acked = mine;
      if (c && c.items) { state = c; paint(); }
    }).catch(function () {
      // let the buffer drain rather than jam on a dropped request
      if (mine === sent) acked = mine;
    });
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-qty-step]');
    if (!btn || btn.disabled) return;

    var line = btn.closest('.bag-line');
    if (!line) return;

    var key = line.getAttribute('data-key');
    var it = itemFor(key);
    if (!it) return;

    var want = it.quantity + Number(btn.getAttribute('data-qty-step'));
    if (want < 1) return;

    touched = true;
    guess(key, want);
    paint();
    announce(want + ' in your bag.');

    /* Collected, not one request per press. One to four sends one request
       for four. A press on a different line flushes the one before it
       rather than losing it. */
    if (queued && queued.key !== key) { clearTimeout(timer); send(); }
    queued = { key: key, quantity: want };
    clearTimeout(timer);
    timer = setTimeout(send, WAIT);
  });

  /* Nothing should be able to leave with a press still sitting in the
     buffer — the checkout button is inches from the plus. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.drawer-checkout, [name="checkout"]') && queued) {
      clearTimeout(timer);
      send();
    }
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.hidden && queued) { clearTimeout(timer); send(); }
  });

  /* theme.js replaces the whole of #cart-lines on every add, remove and
     undo, which takes the steppers with it. Watching its direct children is
     enough: the steppers go inside .bag-id, a level down, so re-inserting
     them cannot trigger this again. This costs no request — the cart it
     paints from is the one already read off theme.js's own fetch. */
  function watch () {
    var host = document.getElementById('cart-lines');
    if (!host || !window.MutationObserver) return;
    new MutationObserver(function () { paint(); }).observe(host, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
}());
